var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n    Your EMR data tabs are empty. Please contact your clinic administrator to set security level so you could view the clinic's data.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }